<ng-template>
  <div class="menu-panel-wrapper" tabindex="-1" role="menu" (click)="closed.emit('click')">
    <div class="menu-panel-content" [class.login-menu-class]="uiLoginMenu">
      <div class="menu-panel-line"></div>
      <ng-content />
    </div>
  </div>
</ng-template>
